omadapp.singletons.domBuilder = new(function() {
    var t = this;
    var $ = jQuery
    t.cargarTemplate = cargarTemplate
    t.crearContenedorEscena = crearContenedorEscena

    function cargarTemplate(idtemplate,idInterface,temporizador, callback) {
        new Cargador(idtemplate, idInterface,temporizador,callback)
    }
    function crearContenedorEscena (id,$pag) {
        var $ce = $('<div class="r-scene scene" data-sceneId="'+id+'"></div>')
        $pag.append($ce)
        return $ce
    }
    function Cargador(idtemplate, idInterface, temporizador,callback) {
        trace ("domBuider->Cargador:constructor "+idtemplate+"  "+idInterface+"  "+temporizador)
        if (idInterface=== "function") {
            trace ('domBuider->Cargador  idInterface=== "function"')
            callback = idInterface
            idInterface = null
        }
        cargarTemplate (idtemplate,idInterface,function(e) {
            cargarTemplate (null,temporizador,function(ee){
                callback(e+ee)
            })
        })
        function cargarTemplate (idtemplate,idInterface,callback) {
            trace ("domBuider->Cargador::cargarTemplate "+idtemplate+"  "+idInterface)
            var principal=""
            if (!idtemplate) {
                cargarInterfaz(idInterface,callback)
                return
            }
            $.ajax({
                url: ctx+"templates/scene_templates/" + idtemplate + ".html",
                context: document.body
            }).done(function(e) {
                if (!idInterface) {
                    callback(e)
                } else {
                    principal = e
                    cargarInterfaz(idInterface,callback)
                }

            });

            function cargarInterfaz(idInterface,callback) {
                trace ("domBuider->Cargador::cargarInterfaz "+idInterface)
                if (!idInterface) {
                    callback("")
                    return
                }
                $.ajax({
                    url: ctx+"templates/interface_templates/" + idInterface + ".html",
                    context: document.body
                }).done(function(e) {
                    if (!idInterface) {
                        callback(e)
                    } else {
                        callback(principal+e)
                    }

                });
            }
        } 

    }

})